import { client } from "./api";

type ILoginProps = {
  email: string;
  password: string;
};

export async function loginService({ email, password }: ILoginProps) {
  const api = client();
  const response = await api.post("users/signIn", { email, password });
  return response.data;
}
